function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { Icon } from '@keen.io/icons';
import { Container, MotionIcon, Hint } from './ListItem.styles';
var iconMotion = {
  initial: {
    opacity: 0,
    left: -5
  },
  animate: {
    opacity: 1,
    left: 0
  },
  exit: {
    opacity: 0
  },
  transition: {
    delay: 0.1
  }
};

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      _onMouseEnter = _ref.onMouseEnter,
      onActive = _ref.onActive,
      isActive = _ref.isActive,
      analysis = _ref.analysis,
      showHint = _ref.showHint;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState({
    top: 0,
    bottom: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      position = _useState4[0],
      setPosition = _useState4[1];

  var elementRef = useRef(null);
  useEffect(function () {
    var _elementRef$current = elementRef.current,
        top = _elementRef$current.offsetTop,
        height = _elementRef$current.clientHeight;
    setPosition({
      top: top,
      bottom: top + height
    });
  }, [elementRef]);
  useEffect(function () {
    if (isActive) onActive(elementRef);
  }, [isActive]);
  var top = position.top,
      bottom = position.bottom;
  return React.createElement(Container, {
    ref: elementRef,
    role: "listitem",
    onClick: function onClick(e) {
      return _onClick(e, analysis);
    },
    isActive: isActive,
    onMouseEnter: function onMouseEnter(e) {
      _onMouseEnter(e);

      setFocus(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setFocus(false);
    }
  }, React.createElement("div", null, children), React.createElement(AnimatePresence, null, React.createElement(Hint, {
    onMouseEnter: function onMouseEnter() {
      return showHint(true, top, bottom);
    },
    onMouseLeave: function onMouseLeave() {
      return showHint(false);
    }
  }, isFocused && React.createElement(MotionIcon, Object.assign({
    "data-testid": "hint-icon",
    key: "hint-icon"
  }, iconMotion), React.createElement(Icon, {
    type: "info",
    width: 15,
    height: 15,
    fill: colors.blue[500]
  })))));
};

export default ListItem;